require('./brokerTransferExternalSuccessStep.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const moment = require('moment');
// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { FIRST_STEP,
        SECOND_STEP,
        BROKER_TYPE_BANK_NAME,
        BROKER_TYPE_AGENCIE,
        BROKER_ALERT_DATE_FORMAT } = require('constants/index');
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

class BrokerTransferExternalSuccessStep extends React.Component {

    getTransferTypeName(transferType) {
        if (transferType.get(BROKER_TYPE_BANK_NAME).get('value')) {
            return formatText('broker-transferExternalBankOrBoxLabel');
        } else if (transferType.get(BROKER_TYPE_AGENCIE).get('value')) {
            return formatText('broker-transferExternalAgencieLabel');
        }
    }

    getTransferTypeValue(transferType, immTransfer) {
        if (transferType.get(BROKER_TYPE_BANK_NAME).get('value')) {
            return immTransfer.getIn(['steps', FIRST_STEP, 'contractNumber']);
        } else if (transferType.get(BROKER_TYPE_AGENCIE).get('value')) {
            return immTransfer.getIn(['steps', FIRST_STEP, 'agencieContract']);
        }
    }

    createInformativeListLeft(mockedBuyingDateTime, orderTypeName, orderTypeValue, isn, titleAmount) {
        return (
            <OKInformativeList>
                <OKInformativeListItem
                    title={formatText('broker-transferExternalSuccessTimeLabel')}
                    bodyText={mockedBuyingDateTime}
                >
                </OKInformativeListItem>
                <OKInformativeListItem
                    title={formatText('broker-transferExternalSuccessOriginLabel')}
                    bodyText={orderTypeName}
                >
                    <div className="stocks-buy-success__contract-number">
                        {orderTypeValue}
                    </div>
                </OKInformativeListItem>
                <OKInformativeListItem
                    title={formatText('broker-transferExternalSuccessValueLabel')}
                    bodyText={isn}
                >
                    <div className="stocks-buy-success__contract-number">
                        {titleAmount} {formatText('broker-transferExternalSuccessTitleLabel')}
                    </div>
                </OKInformativeListItem>

            </OKInformativeList>
        )
    }

    createInformativeListRight(accountName, contractNumber, accountOwner, walletBalance, accountNumber) {
        const plainAmountObject = getPlainAmountObject(walletBalance);

        return (
            <OKInformativeList>
                <OKInformativeListItem
                    title={formatText('stocksContract-ordersContract')}
                    bodyText={accountName}
                >
                    <div className="stocks-buy-success__contract-number">
                        {contractNumber}
                    </div>

                    <div className="stocks-buy-success__related-account">
                        <FormattedText value="stocksContract-firstHolder" />: {accountOwner} <br />
                        <FormattedText value="stocksContract-associatedAccount" />: {accountName} <br />
                        {accountNumber} (<FormattedText
                            value="broker-transferValuesSidebarSecondStepBalance"
                            className="broker-transfer-values-sidebar__label"
                            /><OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                        />)
                    </div>
                </OKInformativeListItem>
            </OKInformativeList>
        )
    }

    render(){
        const { immTransferExternalValues, immTraspassFunds } = this.props;

        const selectedOption = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'accountIdTo']);
        const immFunds =  immTraspassFunds.get('funds');
        const selectedAccount = immFunds.get(selectedOption);
        const accountNumber = selectedAccount.get('associatedAccount');
        const contractNumber = selectedAccount.get('walletNumber');
        const walletBalance = selectedAccount.get('walletBalance');

        const accountOwner = selectedAccount.get('firstTitular');
        const accountName = selectedAccount.get('associatedAccountAlias');

        const orderTypeValue = this.getTransferTypeValue(immTransferExternalValues.getIn(['steps', FIRST_STEP, 'transferType']), immTransferExternalValues);
        const orderTypeName = this.getTransferTypeName(immTransferExternalValues.getIn(['steps', FIRST_STEP, 'transferType']));
        const date = DateHelper.formatDate(moment(new Date()), BROKER_ALERT_DATE_FORMAT);

        const successTitle = formatText('broker-successTitle');
        const successMessage = formatText('broker-transferExternalSuccessTitle');

        const isn = immTransferExternalValues.getIn(['steps', SECOND_STEP, 'valueName']);
        const titleAmount = immTransferExternalValues.getIn(['steps', SECOND_STEP, 'titleAmount']);
        const mainBtn = formatText('broker-transferExternalSuccessMainBtnLabel');
        const secondaryBtn = formatText('broker-transferExternalSuccessScndBtnLabel');

        const informativeListLeft = this.createInformativeListLeft(date, orderTypeName, orderTypeValue, isn, titleAmount);
        const informativeListRight = this.createInformativeListRight(accountName, contractNumber, accountOwner, walletBalance, accountNumber);

        return (
            <WizardSuccess
                successTitle={successTitle}
                successMessage={successMessage}
                customClassName="stocks-buy-success"
                mainButton={{label: mainBtn, url:'/myprofile/broker/general', modifier:'secondary'}}
                secondaryButton={{label:secondaryBtn, url:'/myprofile/broker/transferExternalValues/init', replaceUrl: true}}
            >
                <div className="stocks-buy-success__order-data">
                    <div className="stocks-buy-success__order-data-left">

                        {informativeListLeft}
                    </div>
                    <div className="stocks-buy-success__order-data-right">
                        {informativeListRight}
                    </div>
                </div>
            </WizardSuccess>
        );
    }
}

BrokerTransferExternalSuccessStep.propTypes = {
    immTransferExternalValues: PropTypes.object.isRequired,
    immTraspassFunds: PropTypes.object
};

module.exports = BrokerTransferExternalSuccessStep;
